import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
// import { getLocale } from "react-i18nify";
import dayjs from "dayjs";

import { Avatar } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Stack from "@mui/material/Stack";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

import VisibilityIcon from "@mui/icons-material/Visibility";

import { getUserList } from "src/api/user";

import { useAuth } from "src/hooks/useAuth";
import { checkNotEmpty } from "src/common";

import Main from "src/components/core/Main";
import TextField from "src/components/core/TextField";

const DivMuiContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const DivCount = styled.div`
  margin: 8px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SpanTextCount = styled.p`
  font-weight: 400;
  font-size: 1rem;
  line-height: 24px;
  color: #000000;
  margin: 0;

  span {
    font-weight: 400;
    font-size: 1rem;
    line-height: 24px;
    color: #e04132;
  }
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;

const WrapperSearch = styled.div`
  // margin-bottom: 32px;
  margin-right: 16px;
  width: 65%;
  position: relative;
  display: flex;
  justify-content: center;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
  .MuiTextField-root {
    margin: 0;
  }
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

function UserList({ open }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [userList, setUserList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 10,
    status: "all",
  });
  const [rowCount, setRowCount] = useState(0);

  const columns = [
    {
      field: "name",
      headerName: "User",
      flex: 3,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              margin: "8px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Avatar
              src={params?.row?.user_profile_image}
              size={100}
              backgroundColor="rgba(0,0,0,0)"
              style={{ border: 0, marginRight: "4px" }}
            />
            <div style={{ margin: "8px", width: "50%" }}>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  margin: "5px auto",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row.name}
              </div>

              <div
                className="MuiDataGrid-cellContent"
                style={{
                  margin: "5px auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row.email ? params.row.email : "-"}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  margin: "5px auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row.phone_number ? params.row.phone_number : "-"}
              </div>
            </div>
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date Request",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.createdAt
              ? dayjs(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">{params.row.status ? "ใช้งาน" : " - "}</div>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Preview"
          onClick={() => navigate(`/user/detail/${params.row._id}`)}
          showInMenu
        />,
        // <GridActionsCellItem
        //   icon={
        //     params.row.status === "pending" ? (
        //       <GradingIcon />
        //     ) : (
        //       <VisibilityIcon />
        //     )
        //   }
        //   label={params.row.status === "pending" ? "Approve" : "Preview"}
        //   onClick={() => {
        //     params.row.status === "pending"
        //       ? window.open(`/product/approve/${params.row._id}`, "_self")
        //       : window.open(`/product/preview/${params.row._id}`, "_self");
        //   }}
        //   showInMenu
        // />,
      ],
    },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const fetchUserList = async () => {
    try {
      if (user.role_id === 1) {
        const { data } = await getUserList(dataSearch);
        setUserList(
          data.UserList.data.map((user) => ({
            ...user,
            name:
              user.register_type === 1 // email-pwd
                ? checkNotEmpty(user?.first_name) &&
                  checkNotEmpty(user?.last_name)
                  ? `${user?.first_name} ${user?.last_name}`
                  : "-"
                : user.register_type === 2 // facebook
                  ? user.facebook_name
                  : user.register_type === 3 // google
                    ? user.google_name
                    : "-",
          })),
        );
        setRowCount(data);
      }
    } catch (err) {
      console.error("err:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch, page: 0 });
    fetchUserList();
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };

  useEffect(() => {
    fetchUserList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page, dataSearch.status]);

  return (
    <>
      <Main open={open}>
        <DivMuiContainer>
          <DivMuiInside>
            <WrapperSearch>
              <TextField
                id="search-input"
                placeholder="ค้นหาจากชื่อ อีเมล หรือ เบอร์โทรศัพท์"
                className="TextField-without-border-radius"
                sx={{
                  m: 1,
                  width: "100%",
                  borderRadius: "16px",
                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      id="button-search-seller"
                      sx={{ padding: 0 }}
                      onClick={() => {
                        onSearchButton();
                      }}
                    >
                      <SearchIcon
                        sx={{ color: "#e04132", cursor: "pointer" }}
                      />
                    </IconButton>
                  ),
                }}
                onChange={(e) => {
                  setDataSearch({ ...dataSearch, keyword: e.target.value });
                }}
                onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
              />
            </WrapperSearch>
            {/* <WrapperStatus>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  className="TextField-without-border-radius"
                  id="search-input"
                  label="Age"
                  onChange={(e) => {
                    setDataSearch({ ...dataSearch, status: e.target.value });
                  }}
                >
                  <MenuItem value={"all"}>All</MenuItem>
                  <MenuItem value={"new"}>New</MenuItem>
                  <MenuItem value={"approve"}>Approve</MenuItem>
                  <MenuItem value={"pending"}>Pending</MenuItem>
                  <MenuItem value={"reject"}>Reject</MenuItem>
                </Select>
              </FormControl>
            </WrapperStatus> */}
          </DivMuiInside>

          <DivCount>
            <SpanTextCount>
              ผู้ใช้งานทั้งหมด : <span>{rowCount?.CountAllUser}</span>
            </SpanTextCount>
            <SpanTextCount>
              ผู้ใช้งานใหม่ : <span>{rowCount?.CountNewUser}</span>
            </SpanTextCount>
          </DivCount>

          <WrapperDataGrid>
            <DataGrid
              rows={userList}
              getRowId={(row) => row._id}
              getRowHeight={() => "auto"}
              loading={isLoading}
              columns={columns}
              pageSize={10}
              rowCount={rowCount.UserList?.count}
              paginationMode="server"
              page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              // localeText={{
              //   footerRowSelected: CustomPagination,
              // }}
              components={{
                // Footer: CustomPagination,
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiContainer>
      </Main>
    </>
  );
}

export default UserList;
